import template from '../../templates/PageLayout/Header.rt';

const Header = template;

export default Header;
